import { isDevelopment, TURNSTILE_SITE_KEY as CONFIGURED_TURNSTILE_SITE_KEY } from '../../../constants/env';
import { TURNSTILE_SITE_KEY_GENERATED } from './turnstile-config.generated';

/** Invisible / managed mode — matches `TurnstileWidget` default `size: 'invisible'`. Do not use the visible-only test key `…AA` here. @see https://developers.cloudflare.com/turnstile/troubleshooting/testing/ */
export const TURNSTILE_TEST_SITE_KEY = '1x00000000000000000000BB';

// CI: inject-turnstile-env.js writes the key as a literal before Metro bundles.
// Local dev: falls back to process.env via constants/env.ts (loaded from .env by Expo).
const configuredSiteKey = (TURNSTILE_SITE_KEY_GENERATED || CONFIGURED_TURNSTILE_SITE_KEY).trim();

export const TURNSTILE_SITE_KEY =
  configuredSiteKey && configuredSiteKey.trim().length > 0
    ? configuredSiteKey
    : isDevelopment
      ? TURNSTILE_TEST_SITE_KEY
      : '';

export const TURNSTILE_VERIFY_FAILED_MESSAGE =
  "We couldn't verify you're human. Please try again.";

